import { Component, OnInit, ViewChild, ChangeDetectorRef, HostBinding } from '@angular/core';
import { User } from '../_models/user';
import { AuthenticationService } from '../authentication.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { DamserviceService } from "../dam/damservice.service";
import { Title, Meta } from '@angular/platform-browser';
import { AuthService } from "angularx-social-login";
import { FormBuilder, Validators } from '@angular/forms';
import { Payment } from '../_models/payment';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { ContactUsService } from "../contact-us/contact-us.service";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../environments/environment';
import { SubscriptionService } from "./subscription.service";
import { OrganisationService } from "../create-organisation/organisation.service";
import { AlertService } from "../components/alert/alert.service";
import { LocationService } from "../location/location.service";
import { WindowRefService } from '../services/window-ref.service';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.css']
})
export class SubscriptionComponent  {

  currentUser: User;
  mobileView: boolean = false;
  friendemail: string = '';
  boards = [];
  imagesList = [];
  searchText: string = '';
  currentIllus: any;
  currentBoard: any;
  boardHeading: string = '';
  userRole: string;

  radioYearly: boolean = true;
  detailsYearly: boolean = true;
  radioMonthly: boolean = false;
  radioIndia: boolean = true;
  radioOthers: boolean = false;
  radioIndiaProrata: boolean = true;
  radioOthersProrata: boolean = false;
  showTopRightLoader: boolean = false;
  year: boolean = true;
  month: boolean = false;
  selectedMembership: any = null;
  selectedMembershipBuyNow: any = null;
  payment: Payment;
  public isIndia: boolean = true;
  public isIndiaProrata: boolean = true;
  private month_membership: any = [];
  private year_membership: any = [];
  @ViewChild('paymentSuccess') paymentSuccess;
  paymentSuccessModal: any;
  address: string = '128 santa rosa';
  city: string = 'San Francisco';
  state: string = 'CA';
  country: string = 'US';
  postcode: string = '94014';
  newAmount: string;
  totalUsers: any;
  planId: any;
  isCustomPlan: boolean = false;
  totalPriceFixed: any;
  totalHikedPrice: any;
  couponBtnText: any = "Apply";
  showCouponCodeError: boolean = false;
  couponCodeErrorMsg: any;
  totalPriceFixedPlanUpgrade: any;
  totalPriceFixedHike: any;
  totalPriceFixedDike: any;
  pricePerUser: any;
  returnUrl: any;
  strikeCheckout:any = null;
  memberships = [];
  membershipPlan = [];
  userName: string;
  userEmail: string;
  companyName: string;
  date: string;
  time: string;
  yearlyPlanValue: boolean = true;
  yearlyValue: boolean = true;

  public selectedIndex;
  public index;

  public selectedIndexs;
  public indexs;

  paymentProcessStyle = "none";
  sendingProcessStyle = "none";
  upgradingSeatsProcessStyle = "none";

  showCouponField: boolean = false;
  couponcode: any;

  showMaxSeatsReached: boolean = false;
  showSeatsErrorText: string;

  showLoader: boolean = false;

  sendSuccessfulErrorMsg: boolean = false;
  sendSuccessfulErrorMessage: string;

  planName: String;
  ownerEmail: String;
  ownerName: String;
  invitedUsersList = [];
  notifications = [];
  usersRoles = [];
  userPic: any;
  workspaceId: any
  workspaceName: string;
  workspaceNameDynamic: string;
  workspaces = [];
  totalSpaceAllowed: any;
  consumedSpaceAllowed: any;
  totalSpaceAllowedProgress: any;
  memberRoleId: any;
  addUserCount: any;
  addTotalUserCount: any;
  addStartUserCount: any;
  extraSeatsUserCount: any;
  allowedInviteCount: any;
  availableTimeSlots = [];
  availableSlots = [];
  selectedTime: any;
  selectedDate: any;
  thankYouText: string = "Thank you, select date for a quick call.";

  letsTalkForm = this.fb.group({
    name: ['', Validators.required],
    lname: ['', Validators.required],
    message: ['Enterprise plan query DAM(inside)', Validators.required],
    email: ['', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"), Validators.required]],
    company: ['', Validators.required],
  });

  submitted: Boolean = false;
  reload: Boolean = true;
  aFormGroup: any;

  searchImageslistSection: boolean = false;
  priceDetailsSection: boolean = false;
  planUpgradeSection: boolean = false;
  paymentSuccessSection: boolean = false;
  showPaymentChargebee: boolean = false;
  mainDetailSection: boolean = true;
  hideFaq: boolean = true;
  timeSelected: boolean = false;
  dateSelected: boolean = false;

  showTime: boolean = false;
  showFinalTime: boolean = false;
  showSubmitBtn: boolean = false;
  shownTime: string;
  showDate: boolean = true;
  shownDate: string;
  shownMonth: string;
  shownDay: string;

  isShowError: boolean = false;
  isDateSelected: boolean = false;
  isTimeSelected: boolean = false;
  showSelectionMessage: boolean = false;
  showLeaveLoader: boolean = false;
  showSelectedMsg: string;
  orderId: any;
  totalRazorAmount: any;
  userRazorPayName: string;
  razorPayKey: string;

  planUpGradePrice: any;

  public siteKey?: string = '6Lf59_gUAAAAAEJNHrHp1Vdd1LaG1epuOF62yj80';
  public token?: string;
  public siteKeyV2: string = "6Lf4BvkUAAAAAKreyepy8vMm4ttzZtXIY_0xVJ0O";
  type: string = "checkbox";

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private damService: DamserviceService,
    private subscriptionService: SubscriptionService,
    private authService: AuthService,
    private titleService: Title,
    private metaTagService: Meta,
    private fb: FormBuilder,
    private contacUsService: ContactUsService,
    private reCaptchaV3Service: ReCaptchaV3Service,
    private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private organisationService: OrganisationService,
    private alert: AlertService,
    private locationService: LocationService,
    private winRef: WindowRefService
  ) { }

  @ViewChild('letsTalk') letsTalk;
  @ViewChild('selectDate') selectDate;
  @ViewChild('showloader') showloader;
  @ViewChild('thankyou') thankyou;

  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });
    if (window.screen.width <= 991) { // 768px portrait
      this.mobileView = true;
    }else{
      this.mobileView = false;

    }

    this.titleService.setTitle("Subscribe a plan | Crafttor");
    this.metaTagService.addTags([
      { name: 'description', content: 'Subscription of plans is based on their storage space and invites.'},
      { name: 'keywords', content: 'pricing workspace, subscription workspace, checkout, workspace plan price, price plan' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);

    if (this.currentUser) {
      this.getDamPlans();
      this.getWorkspaceDetails();
      this.getUserPic();
    } else{
      this.router.navigate(['/login']);
    }

    this.isCustomPlan = false;
  }

  getWorkspaceDetails(){
    var details = JSON.parse(localStorage.getItem('workspaceDetails'));
    this.workspaceId = details.workspaceId;
    this.workspaceName = details.workspaceName;
    this.listWorkspace();
  }

  getUserPic() {
    this.damService.getUserPic().subscribe((data: any) => {
      this.userPic = data.user_pic;
    });
  }

  listWorkspace(){
    if (this.currentUser) {
      this.organisationService.getWorkspaceList().subscribe((data: any) => {
        if(data.length > 0){
          this.workspaces = data;
          this.workspaceId = data[0].id;
          this.workspaceName = data[0].title;
          this.workspaceNameDynamic = data[0].title;
          this.userRole = data[0].role;
          this.ownerListApi(this.workspaceId);
          // this.damService.getBoardsList(this.workspaceId).subscribe((data: any) => {
          //   this.boards = data;
          // });
        }else{
          this.router.navigate(['/create-workspace']);
        }
        });
      }else{
        this.router.navigate(['/login']);
      }
    }

  ownerListApi(workspaceId: any){
    this.damService.getOwnerList(workspaceId).subscribe((data: any) => {
      this.ownerEmail = data.email;
      this.planName = data.plan_title;
      this.ownerName = data.first_name + " " + data.last_name;
      this.totalSpaceAllowed = data.allowed_dam_space_kb/1000000;
      this.consumedSpaceAllowed = data.current_dam_space/1000;
      this.totalSpaceAllowedProgress = data.allowed_dam_space_kb/1000;
      this.totalUsers = data.allowed_seats;
      this.planId = data.plan_id;
    });
  }

  selectWorkspace(id: any, title: string){
    this.workspaceName = title;
    this.workspaceId = id;
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: id,
      workspaceName: title }));
      this.router.navigate(['/dam']);
  }

  personalClick(){
    this.router.navigate(['/dam/personal']);
  }

  showUpgradePlans(){
    window.scrollTo(0, 0);
    // this.selectedMembershipBuyNow = membership;
    if (this.currentUser) {
      this.router.navigate(['/dam/subscription']);
    }
  }

  logOut(): void {
    this.authenticationService.logout();
    this.authService.signOut();
    this.router.navigate(['/home']);
  }

  onSubmit() {
    this.searchImages(this.searchText);
  }

  searchImages(searchText: string = ""){
    this.damService.searchImages(searchText).subscribe((data: any) => {
      this.imagesList = data;
      this.searchImageslistSection = true;
    });
  }

  showMainSection() {
    window.scrollTo(0, 0);
    this.priceDetailsSection = false;
    this.paymentSuccessSection = false;
    this.hideFaq = true;
    this.planUpgradeSection = false;
    this.mainDetailSection = true;
  }

  showPayment(membership: any) {
    window.scrollTo(0, 0);
    if (this.currentUser) {
      this.titleService.setTitle("Checkout | Workspace | Crafttor");
      this.mainDetailSection = false;
      this.hideFaq = false;
      this.paymentSuccessSection = false;
      this.planUpgradeSection = false;
      this.priceDetailsSection = true;
      this.selectedMembership = membership;
      this.addUserCount = this.selectedMembership.allowed_seats;
      this.allowedInviteCount = this.selectedMembership.allowed_seats;
      this.totalPriceFixed = (this.selectedMembership.price_yearly*12)*this.addUserCount;
    }
  }

  userCountHike(addUserCount: any, totalPriceFixe: any, selectedMembership: any) {
    if(selectedMembership.title == 'Plus') {
      this.addStartUserCount = addUserCount+1;
      this.couponcode = "";
      this.couponBtnText = "Apply";
      if(this.addStartUserCount < this.selectedMembership.max_allowed_seats) {
        this.addUserCount = this.addStartUserCount;
        this.isCustomPlan = true;
        this.pricePerUser = (this.selectedMembership.price_per_user/100)*100;
        this.totalPriceFixed = this.selectedMembership.price_yearly*12
        this.totalPriceFixed = this.addStartUserCount*this.pricePerUser;
      } else if(this.addStartUserCount == this.selectedMembership.max_allowed_seats) {
        this.addUserCount = this.addStartUserCount;;
        this.isCustomPlan = true;
        this.pricePerUser = (this.selectedMembership.price_per_user/100)*100;
        this.totalPriceFixed = this.selectedMembership.price_yearly*12
        this.totalPriceFixed = this.addStartUserCount*this.pricePerUser;
        this.showMaxSeatsReached = true;
        this.showSeatsErrorText = "Max " + this.selectedMembership.max_allowed_seats +" seats allowed in this plan.";
      }
    } else if(selectedMembership.title == 'Professional') {
      this.addStartUserCount = addUserCount+1;
      this.couponcode = "";
      this.couponBtnText = "Apply";
      if(this.addStartUserCount < this.selectedMembership.max_allowed_seats) {
        this.addUserCount = this.addStartUserCount;
        this.isCustomPlan = true;
        this.pricePerUser = (this.selectedMembership.price_per_user/100)*100;
        this.totalPriceFixed = this.selectedMembership.price_yearly*12
        this.totalPriceFixed = this.addStartUserCount*this.pricePerUser;
      } else if(this.addStartUserCount == this.selectedMembership.max_allowed_seats) {
        this.addUserCount = this.selectedMembership.max_allowed_seats;
        this.isCustomPlan = true;
        this.pricePerUser = (this.selectedMembership.price_per_user/100)*100;
        this.totalPriceFixed = this.selectedMembership.price_yearly*12
        this.totalPriceFixed = this.addStartUserCount*this.pricePerUser;
        this.showMaxSeatsReached = true;
        this.showSeatsErrorText = "Max " + this.selectedMembership.max_allowed_seats +" seats allowed in this plan.";
      }
    }
    // this.totalUsers = this.allowedInviteCount + this.addUserCount;
  }

  userCountDike(addUserCount: any, totalPriceFixe: any, selectedMembership: any) {
    if(addUserCount == this.allowedInviteCount) {
      this.showMaxSeatsReached = false;
      this.addUserCount = this.allowedInviteCount;
      this.couponcode = "";
      this.isCustomPlan = false;
      this.pricePerUser = this.selectedMembership.price_per_user*this.addUserCount;
      this.totalPriceFixed = (this.selectedMembership.price_yearly*12)*this.allowedInviteCount;
    } else {
      this.showMaxSeatsReached = false;
      this.addUserCount = addUserCount-1;
      this.isCustomPlan = true;
      // this.totalUsers = this.allowedInviteCount + this.addUserCount;
      this.pricePerUser = (this.selectedMembership.price_per_user/100)*100;
      // this.totalPriceFixed = this.selectedMembership.price_yearly*12;
      if(this.couponBtnText == 'Remove') {
        this.totalPriceFixed = this.totalHikedPrice-this.pricePerUser;
        this.couponBtnText = "Apply";
      } else {
        this.totalPriceFixed = this.totalPriceFixed-this.pricePerUser;
      }
      this.couponcode = "";
    }
  }

  userPlanUpgradeCountHike(addUserCount: any, totalPriceFixe: any) {
    this.addTotalUserCount = addUserCount+1;
    this.totalUsers = this.allowedInviteCount;
    this.extraSeatsUserCount = this.addTotalUserCount - this.totalUsers;
    this.isCustomPlan = true;
    this.getSeatAmountApi(this.extraSeatsUserCount, addUserCount+1);
  }

  userPlanUpgradeCountDike(addUserCount: any, totalPriceFixe: any) {
    if(addUserCount == this.allowedInviteCount) {
      this.addUserCount = this.allowedInviteCount;
      this.totalUsers = this.allowedInviteCount;
      this.isCustomPlan = false;
      this.extraSeatsUserCount = this.allowedInviteCount;
      // this.getSeatAmountApi(this.extraSeatsUserCount, this.addUserCount);
    } else {
      this.addTotalUserCount = addUserCount-1;
      this.isCustomPlan = true;
      this.totalUsers = this.allowedInviteCount;
      this.extraSeatsUserCount = this.addTotalUserCount - this.totalUsers;
      this.getSeatAmountApi(this.extraSeatsUserCount, addUserCount-1);
    }
  }

  userPlanUpgradeCountHikeRazor(addUserCount: any, totalPriceFixe: any) {
    this.addTotalUserCount = addUserCount+1;
    this.totalUsers = this.allowedInviteCount;
    this.extraSeatsUserCount = this.addTotalUserCount - this.totalUsers;
    this.isCustomPlan = true;
    this.getSeatAmountApiRazor(this.extraSeatsUserCount, addUserCount+1);
  }

  userPlanUpgradeCountDikeRazor(addUserCount: any, totalPriceFixe: any) {
    if(addUserCount == this.allowedInviteCount) {
      this.addUserCount = this.allowedInviteCount;
      this.totalUsers = this.allowedInviteCount;
      this.isCustomPlan = false;
      this.extraSeatsUserCount = this.allowedInviteCount;
      // this.getSeatAmountApiRazor(this.extraSeatsUserCount, this.addUserCount);
    } else {
      this.addTotalUserCount = addUserCount-1;
      this.isCustomPlan = true;
      this.totalUsers = this.allowedInviteCount;
      this.extraSeatsUserCount = this.addTotalUserCount - this.totalUsers;
      this.getSeatAmountApiRazor(this.extraSeatsUserCount, addUserCount-1);
    }
  }

  getSeatAmountApi(userCount: any, totalUserCount: any) {
    if(this.planName == 'Plus') {
      // this.upgradingSeatsProcessStyle = "block";
      this.damService.getSeatAmount("3", userCount).subscribe((data: any) => {
        this.totalPriceFixedPlanUpgrade = this.planUpGradePrice + data.new_amount;
        this.addUserCount = totalUserCount;
        this.upgradingSeatsProcessStyle = "none";
      },
      (error) => {
        this.upgradingSeatsProcessStyle = "none";
      });
    } else {
      // this.upgradingSeatsProcessStyle = "block";
      this.damService.getSeatAmount(this.planId, userCount).subscribe((data: any) => {
        this.totalPriceFixedPlanUpgrade = this.planUpGradePrice + data.new_amount;
        this.addUserCount = totalUserCount;
        this.upgradingSeatsProcessStyle = "none";
      },
      (error) => {
        this.upgradingSeatsProcessStyle = "none";
      });
    }
  }

  getSeatAmountApiRazor(userCount: any, totalUserCount: any) {
    if(this.planName == 'Plus') {
      this.upgradingSeatsProcessStyle = "block";
      this.damService.getUpgradeSeatAmountRazor("3", userCount).subscribe((data: any) => {
        this.totalPriceFixedPlanUpgrade = data.total_new_amount_to_be_paid;
        this.addUserCount = totalUserCount;
        this.upgradingSeatsProcessStyle = "none";
      },
      (error) => {
        this.upgradingSeatsProcessStyle = "none";
      });
    } else {
      this.upgradingSeatsProcessStyle = "block";
      this.damService.getUpgradeSeatAmountRazor(this.planId, userCount).subscribe((data: any) => {
        this.totalPriceFixedPlanUpgrade = data.total_new_amount_to_be_paid;
        this.addUserCount = totalUserCount;
        this.upgradingSeatsProcessStyle = "none";
      },
      (error) => {
        this.upgradingSeatsProcessStyle = "none";
      });
    }
  }

  openLetsTalkDialog(modal){
      this.letsTalk = this.modalService.open(modal, { centered: true, windowClass: 'sign-up ' });
  }

  openThankskDialog(modal){
      this.thankyou = this.modalService.open(modal, { centered: true, windowClass: 'thanks-popup ' });
  }

  openSelectTimeDialog(modal){
      this.selectDate = this.modalService.open(modal, { centered: true, windowClass: 'select-time-popup ' });
  }

  chooseMonthly(){
    this.radioYearly=false;
    this.radioMonthly=true;
  }

  chooseYearly(){
    this.radioMonthly=false;
    this.radioYearly=true;
  }

  chooseIndia(){
    this.radioOthers=false;
    this.radioIndia=true;
    this.isIndia = true;
  }

  chooseOthers(){
    this.radioIndia=false;
    this.radioOthers=true;
    this.isIndia = false;
  }

  chooseIndiaProrata(){
    this.radioOthersProrata=false;
    this.radioIndiaProrata=true;
    this.isIndiaProrata = true;
  }

  chooseOthersProrata(){
    this.radioIndiaProrata=false;
    this.radioOthersProrata=true;
    this.isIndiaProrata = false;
  }

  public submitContactUs(modal) {
    this.submitted = true;
    if (this.letsTalkForm.valid) {
      this.showLeaveLoader = true;
      this.reCaptchaV3Service.execute(this.siteKey, 'contact_us', (token) => {
        this.letsTalkForm.value['recaptcha'] = token;
        this.cdr.detectChanges();
        this.userName = this.letsTalkForm.value['name'] +" "+this.letsTalkForm.value['lname'];
        this.userEmail = this.letsTalkForm.value['email'];
        this.companyName = this.letsTalkForm.value['company'] +" : " +this.letsTalkForm.value['message'];
        this.date = this.letsTalkForm.value['date'];
        this.time = this.letsTalkForm.value['time_start'];
        this.letsTalkForm.reset()
        this.letsTalk.close();
        this.showLeaveLoader = false;
        this.getDateListApi();
        this.selectDate = this.modalService.open(modal, { centered: true, windowClass: 'select-time-popup ' });
      });
    }
  }

  getDateListApi() {
    this.subscriptionService.getDateCall().subscribe((data: any) => {
      this.availableSlots = data;
      this.getTimeListApi(data[0].date);
    });
  }

  getTimeListApi(date: any) {
    this.subscriptionService.getTimeCall(date).subscribe((data: any) => {
      this.availableTimeSlots = data;
    });
  }

  contactSalesCall(modal) {
    if(this.isDateSelected == true && this.isTimeSelected == true) {
      this.sendingProcessStyle = "block";
       this.subscriptionService.contactSalesCallApi(this.userName, this.userEmail, this.companyName,
         this.selectedDate, this.selectedTime).subscribe((data) => {
         this.showLeaveLoader = false;
         this.submitted = false;
         this.sendingProcessStyle = "none";
         this.openThankskDialog(modal);
       },(error: any) => {
         if(error.status == 400){
           this.showLeaveLoader = false;
           this.submitted = false;
           this.sendingProcessStyle = "none";
           this.alert.error(error.error.message);
         } else {
           this.showLeaveLoader = false;
           this.submitted = false;
           this.sendingProcessStyle = "none";
           this.alert.error(error.error.message);
         }
      });
    } else if(this.isDateSelected == false) {
      this.showLeaveLoader = false;
      this.showSelectionMessage = true;
      this.showSelectedMsg = "Select Date";
    } else if(this.isTimeSelected == false) {
      this.showLeaveLoader = false;
      this.showSelectionMessage = true;
      this.showSelectedMsg = "Select Time";
    }
  }

  goToWorkspace() {
    this.thankyou.close();
    this.router.navigate(['/dam']);
  }

  selectDateSales(date: string, day: string, month: string) {
    this.selectedDate = date;
    this.showDate = false;
    this.isDateSelected = true;
    this.dateSelected = true;
    this.showSubmitBtn = true;
    this.showSelectionMessage = false;
    this.thankYouText = "Thank You!! select time."

    this.getTimeListApi(date);
    this.showTime = true;
    this.timeSelected = false;
    this.showFinalTime = false;

    this.shownMonth = month;
    if(day == 'Mon') {
      this.shownDay = "Monday";
    } else if(day == 'Tue') {
      this.shownDay = "Tuesday";
    } else if(day == 'Wed') {
      this.shownDay = "Wednesday";
    } else if(day == 'Thu') {
      this.shownDay = "Thursday";
    } else if(day == 'Fri') {
      this.shownDay = "Friday";
    } else if(day == 'Sat') {
      this.shownDay = "Saturday";
    } else if(day == 'Sun') {
      this.shownDay = "Sunday";
    }

    let stringToSplit = this.selectedDate;
    let splitDate = stringToSplit.split("-");

    if(splitDate[1] == '01') {
      this.shownDate = "Jan" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '02') {
      this.shownDate = "Feb" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '03') {
      this.shownDate = "March" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '04') {
      this.shownDate = "April" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '05') {
      this.shownDate = "May" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '06') {
      this.shownDate = "June" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '07') {
      this.shownDate = "Julu" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '08') {
      this.shownDate = "Aug" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '09') {
      this.shownDate = "Sept" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '10') {
      this.shownDate = "Oct" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '11') {
      this.shownDate = "Nov" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '12') {
      this.shownDate = "Dec" +" "+ splitDate[2] +", "+splitDate[0];
    }
  }

  changeDate() {
    this.showDate = true;
    this.isDateSelected = false;
    this.dateSelected = false;
    this.showSubmitBtn = false;
    this.showSelectionMessage = false;
    this.showTime = false;
    this.isTimeSelected = false;
    this.timeSelected = false;
    this.showFinalTime = false;
    // this.getTimeListApi(this.availableSlots[0].date);
  }

  selectTimeSales(time) {
    this.selectedTime = time;
    this.showTime = false;
    this.showSubmitBtn = true;
    this.shownTime = time;
    this.showFinalTime = true;
    this.isTimeSelected = true;
    this.showSelectionMessage = false;
    this.timeSelected = true;
    this.thankYouText = "Thank You!! you meeting will be scheduled."
  }

  changeTime() {
    this.showTime = true;
    this.isTimeSelected = false;
    this.timeSelected = false;
    this.showSelectionMessage = false;
  }

  getDamPlans(){
    this.showTopRightLoader = true;
    this.subscriptionService.getDamPlans().subscribe((data: any) => {
      this.showTopRightLoader = false;
      this.memberships = data;
      this.membershipPlan = data;
    },(error: any) => {
      if(error.status == 400 || error.status == 403){
        this.showTopRightLoader = false;
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunction();
      } else {
        this.showTopRightLoader = false;
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunction();
      }
   });
  }

  changeColor(i){
      this.selectedIndex = i;
  }

  changeColors(i){
      this.selectedIndexs = i;
  }

  yearly(){
    this.yearlyPlanValue = true;
    this.memberships = this.memberships;
  }
  monthly(){
    this.yearlyPlanValue = false;
    this.memberships = this.memberships;
  }

  yearlyPlan(){
    this.yearlyValue = true;
    this.membershipPlan = this.memberships;
  }
  monthlyPlan(){
    this.yearlyValue = false;
    this.membershipPlan = this.memberships;
  }

  checkoutStripe(amount, currency, membership) {
    const strikeCheckout = (<any>window).StripeCheckout.configure({
      key: environment.STRIPE_LIVE_KEY,
      locale: 'auto',
      token: (stripeToken: any) => {
        if(this.planName == 'Plus') {
          this.paymentProcessStyle = "block";
          this.subscriptionService.postStripeOrderPlanUpgrade(stripeToken, amount, currency,
            membership.id, this.currentUser.firstName+" "+ this.currentUser.lastName,
            this.address, this.city, this.state, this.country, this.postcode,
            this.totalPriceFixed, this.addUserCount, this.isCustomPlan, membership.id).subscribe((data) => {
            this.mainDetailSection = false;
            this.priceDetailsSection = false;
            this.hideFaq = false;
            this.planUpgradeSection = false;
            this.paymentProcessStyle = "none";
            this.paymentSuccessSection = true;
          },
          (error) => {
            const errors = error.error || error.statusText;
            Object.keys(errors).map((key) => {
              errors[key].map((message) => {
                this.mainDetailSection = false;
                this.hideFaq = false;
                this.planUpgradeSection = false;
                this.paymentProcessStyle = "none";
                this.paymentSuccessSection = false;
                this.priceDetailsSection = true;
                this.alert.error(message);
              })
            })
         });
        } else {
          this.paymentProcessStyle = "block";
          this.subscriptionService.postStripeOrder(stripeToken, amount, currency,
            membership.id, this.currentUser.firstName+" "+ this.currentUser.lastName,
            this.address, this.city, this.state, this.country, this.postcode,
            this.totalPriceFixed, this.addUserCount, this.isCustomPlan, this.couponcode).subscribe((data) => {
            this.mainDetailSection = false;
            this.priceDetailsSection = false;
            this.hideFaq = false;
            this.paymentProcessStyle = "none";
            this.planUpgradeSection = false;
            this.paymentSuccessSection = true;
          },(error: any) => {
            this.upgradingSeatsProcessStyle = "none";
            if(error.status == 400 || error.status == 406){
              this.mainDetailSection = false;
              this.hideFaq = false;
              this.paymentProcessStyle = "none";
              this.paymentSuccessSection = false;
              this.planUpgradeSection = false;
              this.priceDetailsSection = true;
              this.alert.error("Payment issue. Please try again!!");
            } else {
              this.mainDetailSection = false;
              this.hideFaq = false;
              this.paymentProcessStyle = "none";
              this.paymentSuccessSection = false;
              this.planUpgradeSection = false;
              this.priceDetailsSection = true;
              this.alert.error("Payment issue. Please try again!!");
            }
         });
        }
      }
    });

    strikeCheckout.open({
      name: 'Crafttor',
      description: 'Stripe Payment Gateway',
      image: 'https://crafttor.com/crafttor.jpg',
      currency: currency,
      amount: this.totalPriceFixed * 100
    });
  }

stripePaymentGateway() {
  if(!window.document.getElementById('stripe-script')) {
    const scr = window.document.createElement("script");
    scr.id = "stripe-script";
    scr.type = "text/javascript";
    scr.src = "https://checkout.stripe.com/checkout.js";

    scr.onload = () => {
      this.strikeCheckout = (<any>window).StripeCheckout.configure({
        key: environment.STRIPE_LIVE_KEY,
        locale: 'auto',
        token: function (token: any) {
        console.log(token)
        alert('Payment via stripe successfull!');
        }
      });
    }
    window.document.body.appendChild(scr);
    }
  }

  switchToWorkspace(){
    window.scrollTo(0, 0);
    // this.selectedMembershipBuyNow = membership;
    if (this.currentUser) {
      this.router.navigate(['/dam']);
    }
  }

  upgradeOldPlanWithNew(planId: any) {
    this.isShowError = false;
    this.upgradingSeatsProcessStyle = "block";
    this.subscriptionService.getUpgradePlanDetails(planId).subscribe((data: any) => {
      this.isShowError = false;
      this.planUpGradePrice = data.total_new_amount_to_be_paid;
      this.totalPriceFixedPlanUpgrade = data.total_new_amount_to_be_paid;
      this.upgradingSeatsProcessStyle = "none";
    },(error: any) => {
      this.upgradingSeatsProcessStyle = "none";
      if(error.status == 400){
        this.isShowError = true;
      } else {
        this.isShowError = true;
      }
   });
  }

  upgradeOldPlanWithNewRazor(planId: any) {
    this.isShowError = false;
    this.upgradingSeatsProcessStyle = "block";
    this.subscriptionService.getUpgradePlanDetailsRazor(planId).subscribe((data: any) => {
      this.isShowError = false;
      this.planUpGradePrice = data.total_new_amount_to_be_paid;
      this.totalPriceFixedPlanUpgrade = data.total_new_amount_to_be_paid;
      this.upgradingSeatsProcessStyle = "none";
    },(error: any) => {
      this.upgradingSeatsProcessStyle = "none";
      if(error.status == 400){
        this.isShowError = true;
      } else {
        this.isShowError = true;
      }
   });
  }

  checkoutStripeUpgradePlan(amount, currency, membership) {
    const strikeCheckout = (<any>window).StripeCheckout.configure({
      key: environment.STRIPE_LIVE_KEY,
      locale: 'auto',
      token: (stripeToken: any) => {
        this.paymentProcessStyle = "block";
        this.subscriptionService.postStripeOrderPlanUpgradeProRata(stripeToken, this.totalPriceFixedPlanUpgrade, currency,membership.id, this.currentUser.firstName+" "+ this.currentUser.lastName,
          this.address, this.city, this.state, this.country, this.postcode,
          this.totalPriceFixedPlanUpgrade, this.addUserCount, this.isCustomPlan, membership.id, this.extraSeatsUserCount).subscribe((data) => {
          this.mainDetailSection = false;
          this.priceDetailsSection = false;
          this.planUpgradeSection = false;
          this.paymentProcessStyle = "none";
          this.hideFaq = false;
          this.totalPriceFixed = this.totalPriceFixedPlanUpgrade;
          this.paymentSuccessSection = true;
        },
        (error) => {
          const errors = error.error || error.statusText;
          Object.keys(errors).map((key) => {
            errors[key].map((message) => {
              this.mainDetailSection = false;
              this.hideFaq = false;
              this.paymentProcessStyle = "none";
              this.paymentSuccessSection = false;
              this.priceDetailsSection = false;
              this.planUpgradeSection = true;
              this.alert.error(message);
            })
          })
       });
      }
    });

    strikeCheckout.open({
      name: 'Crafttor',
      description: 'Stripe Payment Gateway',
      image: 'https://crafttor.com/crafttor.jpg',
      currency: currency,
      amount: this.totalPriceFixedPlanUpgrade * 100
    });
  }

  getCurrentPlanDetails(membership: any) {
    if(this.planName == 'Plus') {
      if (this.currentUser) {
        if(this.isIndiaProrata == true) {
          this.upgradeOldPlanWithNewRazor(membership.id);
          this.titleService.setTitle("Checkout | Workspace | Crafttor");
          this.selectedMembership = membership;
          this.totalPriceFixed = this.selectedMembership.price_yearly*12;
          this.addUserCount = this.selectedMembership.allowed_seats;
          this.allowedInviteCount = this.selectedMembership.allowed_seats;
          this.mainDetailSection = false;
          this.hideFaq = false;
          this.paymentSuccessSection = false;
          this.priceDetailsSection = false;
          this.planUpgradeSection = true;
        } else {
          this.upgradeOldPlanWithNew(membership.id);
          this.titleService.setTitle("Checkout | Workspace | Crafttor");
          this.selectedMembership = membership;
          this.totalPriceFixed = this.selectedMembership.price_yearly*12;
          this.addUserCount = this.selectedMembership.allowed_seats;
          this.allowedInviteCount = this.selectedMembership.allowed_seats;
          this.mainDetailSection = false;
          this.hideFaq = false;
          this.paymentSuccessSection = false;
          this.priceDetailsSection = false;
          this.planUpgradeSection = true;
        }
      }
    } else {
      this.showPayment(membership);
    }
  }

  showPaymentPage(amount: any, currency: any, membership: any) {
    localStorage.setItem('priceDetails', JSON.stringify({ chargeAmount: amount, chargeCurrency: currency,
      chargeMembership: membership }));
    // this.router.navigate(['/dam/payment']);
  }

  createRzpayOrder(amount: any, currency: any, membership: any) {
    this.userRazorPayName = this.currentUser.firstName+" "+ this.currentUser.lastName;
    this.subscriptionService.getRazorOrderId(this.userRazorPayName, this.totalPriceFixed,
      currency, membership.id, this.isCustomPlan, this.addUserCount, this.couponcode).subscribe((data: any) => {
      this.orderId = data.razorpay_order_id;
      this.totalRazorAmount = data.razorpay_amount;
      this.razorPayKey = data.razorpay_merchant_key;
      this.payWithRazor(this.orderId, this.razorPayKey, this.totalRazorAmount,
        this.userRazorPayName, membership.id, this.totalPriceFixed,
        this.addUserCount, this.couponcode);
    },(error: any) => {
      if(error.status == 400){
        this.alert.error(error.error.message)
      } else {
        this.alert.error(error.error.message)
      }
   });
  }

  createRzpayOrderUpgrade(amount: any, currency: any, membership: any) {
    this.userRazorPayName = this.currentUser.firstName+" "+ this.currentUser.lastName;
    this.damService.getUpgradeSeatAmountRazor(membership.id, this.extraSeatsUserCount).subscribe((data: any) => {
      this.orderId = data.razorpay_order_id;
      this.totalRazorAmount = data.razorpay_amount;
      this.razorPayKey = data.razorpay_merchant_key;
      this.payWithRazorProrata(this.orderId, this.razorPayKey, this.totalRazorAmount,
        this.userRazorPayName, membership.id, this.totalPriceFixed, this.addUserCount);
    },(error: any) => {
      if(error.status == 400){
        this.alert.error(error.error.message)
      } else {
        this.alert.error(error.error.message)
      }
   });
  }

  payWithRazor(val: any, key: any, totalAmount: any, userName: any,
    planId: any, totalValue: any, totalSeats: any, couponCode: any) {
    localStorage.setItem('paymentRazorDetails', JSON.stringify({ totalAmount: totalAmount}));
    const options: any = {
      key: key,
      amount: totalAmount*100,
      currency: 'USD',
      name: 'Crafttor', // company name or product name
      description: '',  // product description
      image: 'https://crafttor.com/crafttor.jpg', // company logo or product image
      order_id: val, // order_id created by you in backend
      modal: {
        // We should prevent closing of the form when esc key is pressed.
        escape: false,
      },
      notes: {
        // include notes if any
      },
      theme: {
        color: '#0c238a'
      }
    };
    options.handler = ((response, error) => {
      options.response = response;
      this.subscriptionService.payRazorAmountOrderId(response.razorpay_payment_id,
        response.razorpay_order_id,response.razorpay_signature, userName, planId,
        totalValue, totalSeats, this.isCustomPlan, this.couponcode).subscribe((data: any) => {
          this.router.navigate(['/dam/payment-success']);
      },(error: any) => {
        if(error.status == 400){
          this.alert.error(error.error.message)
        } else {
          this.alert.error(error.error.message)
        }
     });
    });
    options.modal.ondismiss = (() => {
      // handle the case when user closes the form while transaction is in progress
      console.log('Transaction cancelled.');
    });
    const rzp = new this.winRef.nativeWindow.Razorpay(options);
    rzp.open();
    // this.hideSuccesfullFunctionMsg();
  }

  payWithRazorProrata(val: any, key: any, totalAmount: any, userName: any,
    planId: any, totalValue: any, totalSeats: any) {
    localStorage.setItem('paymentRazorDetails', JSON.stringify({ totalAmount: this.totalPriceFixedPlanUpgrade}));
    const options: any = {
      key: key,
      amount: totalAmount*100,
      currency: 'USD',
      name: 'Crafttor', // company name or product name
      description: '',  // product description
      image: 'https://crafttor.com/crafttor.jpg', // company logo or product image
      order_id: val, // order_id created by you in backend
      modal: {
        // We should prevent closing of the form when esc key is pressed.
        escape: false,
      },
      notes: {
        // include notes if any
      },
      theme: {
        color: '#0c238a'
      }
    };
    options.handler = ((response, error) => {
      options.response = response;
      this.subscriptionService.postRazorOrderPlanUpgradeProRata(this.totalPriceFixedPlanUpgrade, "USD",
        planId, this.currentUser.firstName+" "+ this.currentUser.lastName,
        this.address, this.city, this.state, this.country, this.postcode,
        this.totalPriceFixedPlanUpgrade, this.addUserCount, this.isCustomPlan, planId, this.extraSeatsUserCount, response.razorpay_payment_id,response.razorpay_order_id,response.razorpay_signature).subscribe((data: any) => {
          this.router.navigate(['/dam/payment-success']);
      },(error: any) => {
        if(error.status == 400){
          this.alert.error(error.error.message)
        } else {
          this.alert.error(error.error.message)
        }
     });
    });
    options.modal.ondismiss = (() => {
      // handle the case when user closes the form while transaction is in progress
      console.log('Transaction cancelled.');
    });
    const rzp = new this.winRef.nativeWindow.Razorpay(options);
    rzp.open();
    // this.hideSuccesfullFunctionMsg();
  }

  hideSuccesfullFunctionMsg(){
    setTimeout(() => {
      this.upgradingSeatsProcessStyle = "block";
    }, 5000);
  }

  goToMarketplace() {
    window.open("https://crafttor.com/marketplace", "_blank");
  }

  showCouponFieldClick() {
    this.showCouponField = true;
  }

  hideErroMsg() {
    this.showCouponCodeError = false;
  }

  applyCouponCode() {
    if(this.couponcode == 'SEASON50' || this.couponcode == 'season50'){
      this.showCouponCodeError = false;
      this.couponCodeErrorMsg = "";
      if(this.couponBtnText == 'Apply') {
        this.totalHikedPrice = this.totalPriceFixed;
        this.totalPriceFixed = this.totalPriceFixed/2;
        this.couponBtnText = "Remove";
      } else if (this.couponBtnText == 'Remove') {
        this.totalPriceFixed = this.totalPriceFixed*2;
        this.couponBtnText = "Apply";
        this.couponcode = "";
      }
    } else {
      this.showCouponCodeError = true;
      this.couponCodeErrorMsg = "Invalid coupon";
    }
  }

  openFigma() {
    window.open("https://www.figma.com/community/plugin/902086023682633830/Crafttor", "_blank");
  }

  openSketch() {
    window.open("https://crafttor.com/sketch", "_blank");
  }

  openIllustrator() {
    window.open("https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator", "_blank");
  }

  getNotifications() {
    this.showLoader = true;
    this.newNotification ();
  }

  newNotification () {
    this.damService.newNotifications(this.workspaceId).subscribe((data: any) => {
      this.notifications = data['notifcation'];
      this.showLoader = false;
    });
  }

  getName(fullEmail: string) {
    return fullEmail.split(' ').map(n => n[0]).join('').toUpperCase();
  }

  hideSuccesfullFunction(){
    setTimeout(() => {
      this.sendSuccessfulErrorMsg = false;
    }, 3000);
  }

  getRandomColor() {
    var color = Math.floor(0x1000000 * Math.random()).toString(16);
    return '#' + ('000000' + color).slice(-6);
  }
}
